import { DataType } from "@dndModels/Types";
import { ModelBase } from "@models/UpsertableBase";

/**
 * 
 */
export class ReusableString extends ModelBase {
  data_type: DataType = "reusable_string";
  label = "";
  // content: string = "";
  
  constructor(obj?: any) {
    super(obj);
    if (obj) {
      this.label = obj.label ? obj.label : "";
      // this.content = obj.content ? obj.content : "";
      if (obj.content) {
        this.description = obj.content;
      }
    }
  }

  // load(obj: any): void {
  //   super.load(obj);
  //   if (obj) {
  //     this.label = obj.label ? obj.label : "";
  //     // this.content = obj.content ? obj.content : "";
  //     if (obj.content) {
  //       this.description = obj.content;
  //     }
  //   }
  // }

  get content() {
    return this.description;
  }

  // set content(value: string) {
  //   this.description = value;
  // }

  toDBObj(): any {
    const base_obj = super.toDBObj();
    return {
      ...base_obj,
      label: this.label,
      // content: this.content
    };
  }

  copy(copyMe: ReusableString, drop_ids = false): void {
    super.copy(copyMe, drop_ids);
    this.label = copyMe.label;
    // this.content = copyMe.content;
  }

  clone(drop_ids = false): ReusableString {
    const new_obj = new ReusableString();
    new_obj.copy(this, drop_ids);
    return new_obj;
  }
}

